import React from 'react'
import styled from 'styled-components'

import {
  UlUser, LiUser,
} from '../../common/formParts/FieldPartsStyled'


const DeliveryDestinationFieldShow = (props) => {
  const destinations = props.delivery_destinations

  const translateDestinationName = (destination_name) => {
    if (destination_name === 'app') {
      return 'アプリ'
    } else if (destination_name === 'article') {
      return '物件'
    } else if (destination_name === 'delivery_group') {
      return '配信グループ'
    } else if (destination_name === 'member_dwelling_unit') {
      return '会員住戸'
    }
  }

  const downloadMembersList = (delivery_destination) => {
    const selected_members = delivery_destination.selected_members
    // define headers
    const headers = [
      '会員ID',
      '会員住戸ID',
      '会員名',
      '部屋番号',
    ]
    const csvHeader = headers.join(',')
    // define data
    const csv = selected_members.map((user) => {
      return `${user.user_id},${user.user_article_id},${user.name},${user.room || ''}`
    }).join("\n")

    var exportedFilename = delivery_destination.destination_name + '-配信先の会員リスト.csv' || 'members.csv'

    const csvBlob = new Blob(
      ['\ufeff' + csvHeader + "\n" + csv],
      { type: 'text/csv;charset=utf-8;' }
    )
    const url = window.URL.createObjectURL(csvBlob)
    const a = document.createElement('a')

    if (a.download !== undefined) { // feature detection
      a.setAttribute('href', url)
      a.setAttribute('download', exportedFilename)
      a.style.visibility = 'hidden'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }

  return (
    <DDShow>
      {destinations.map((delivery_destination, index) => {
        return (
          <dl>
            <dt className="attribute-label" id="<%= news_destination.destination_type.downcase %>">配信先 {index + 1}</dt>
            <dd className="attribute-data">
              {delivery_destination.selected_members.length > 0 && (
                <div>
                  <div className="target-article">
                    <div className="label">物件</div>
                    <div className="value">{delivery_destination.destination_name}</div>
                  </div>

                  <div className="target-user-article">
                    <div>対象の会員住戸 (<b>{delivery_destination.selected_members.length}</b>)</div>
                    <a href='#' onClick={(e) => { e.preventDefault(); downloadMembersList(delivery_destination) }}>配信先の会員リストをダウンロードする</a>
                  </div>

                  <ul className="list-head">
                    <LiUser key={`user-head-` + index} className='selectedUsers'>
                      <div>会員名</div>
                      <div>部屋番号</div>
                    </LiUser>
                  </ul>
                  <UlUser className="list-body">
                    {delivery_destination.selected_members.map((user, index) => {
                      return (
                        <LiUser key={`user-` + index} className='selectedUsers'>
                          <a href={`/manage/users/${user.user_id}`}><div>{user.name}</div></a>
                          <div>{user.room || '-'}</div>
                        </LiUser>
                      )
                    })}
                  </UlUser>
                </div>
              )}

              {delivery_destination.selected_members.length === 0 && (
                <div>
                  {translateDestinationName(delivery_destination.name.toLowerCase())}<br />
                  {delivery_destination.destination_name}
                </div>
              )}
            </dd>
          </dl>
        )
      })}
    </DDShow>
  )
}

export default DeliveryDestinationFieldShow

const DDShow = styled.div`
  .target-article {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    .label {
      display: inline-block;
      padding: 0.25rem 0.5rem;
      margin-right: 0.5rem;
      font-size: 13px;
      text-align: center;
      background-color: #e5e5e5;
      border-radius: 4px;
    }
  }
  .target-user-article {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .list-head {
    margin-top: 1rem;
    background: #F5F5F5;
    border: 1px solid #CCC;
    border-bottom: 0;
    border-radius: 4px 4px 0 0;
    li {
      cursor: default;
      padding-left: 0;
    }
  }
  .list-body {
    border: 1px solid #CCC;
    border-radius: 0 0 4px 4px;
  }
`
